import { Box, Container, Fade, CircularProgress } from "@mui/material";
import { Navigate, useNavigate, Route, Routes } from "react-router";
import { SlideInContextProvider } from "../../context/SlideInContext";
import SlideIn from "../components/SlideIn";
import AppBar from "../components/AppBar";
import ViewCompanyInfo from "./ViewCompanyInfo";
import CompanyStatsPage from "./CompanyStatsPage";
import CompanyLocationPage from "./CompanyLocationPage"
import CompanyStudentStats from "./CompanyStudentStats";
import ManageCompanyStaffPage from "./ManageCompanyStaffPage";
import { ManageModal, ManageModalProvider } from "ui";
const CompanyManagementRoutes = () => {
    const navigate = useNavigate();
    // const params = useParams();
    // if (params.lid) { 

    // }
    return (
        <Routes>
            <Route index element={<ViewCompanyInfo onBack={() => navigate(-1)} />} />
            <Route path="location/:lid" element={<CompanyLocationPage onBack={() => navigate(-1)} />} />
            <Route path="location/:lid/staff" element={<ManageCompanyStaffPage onBack={() => navigate(-1)} />} />
            <Route path="students" element={<CompanyStudentStats onBack={() => navigate(-1)} />} />
            <Route path="stats" element={<CompanyStatsPage onBack={() => navigate(-1)} />} />
            <Route path="*" element={<Navigate to="." replace />} />
        </Routes>
    )
}

export const CompanyIndexPage = () => {
    const loading = false;

    return (
        <Fade in={true}>
            <Box component="div">
                <SlideInContextProvider>
                    <ManageModalProvider>
                        <ManageModal />
                        <div>
                            <SlideIn />
                            <AppBar />
                        </div>
                        <Container maxWidth="xl">
                            <Box component="div" sx={{ paddingTop: "40px", paddingBottom: "32px" }}>
                                {loading ? (
                                    <div
                                        style={{
                                            width: "100%",
                                            height: "50vh",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <CircularProgress />
                                    </div>
                                ) : (
                                    <CompanyManagementRoutes />
                                )}
                            </Box>
                        </Container>
                    </ManageModalProvider>
                </SlideInContextProvider>
            </Box>
        </Fade>
    )
}